// extracted by mini-css-extract-plugin
module.exports = {"userQuotesContainer":"UserQuotes_userQuotesContainer__Hw4W5"};